import { PublicClientApplication } from '@azure/msal-browser'
import { msalConfig, loginRequest } from './msalConfig'

const msalInstance = new PublicClientApplication(msalConfig)
const _initialized = msalInstance.initialize()

const ssoService = {
  // Redirect the entire page to Microsoft login
  // Simpler than popup — no cross-window issues
  async login() {
    await _initialized
    await msalInstance.loginRedirect(loginRequest)
    // Page redirects away — this never returns
  },

  // Called on page load after Entra redirects back with the code
  // Returns the auth result if this is a redirect response, null otherwise
  async handleRedirect() {
    await _initialized
    return await msalInstance.handleRedirectPromise()
  },

  async logout() {
    await _initialized
    await msalInstance.logoutRedirect()
  },

  async getAccessToken() {
    await _initialized
    const accounts = msalInstance.getAllAccounts()
    if (!accounts.length) return null
    const response = await msalInstance.acquireTokenSilent({
      ...loginRequest,
      account: accounts[0],
    })
    return response.idToken
  },
}

export default ssoService